import React, { useState } from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";

function useAlumHandleSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const withHandleChoice = useStore((state) => state.quote.withHandle);
  const withKeyChoice = useStore((state) => state.quote.withKey);

  const handleStyle = useStore((state) => state.quote.handleStyle);
  const finish = useStore((state) => state.quote.handleColor);

  const doorType = useStore((state) => state.quote.doorType);

  const [open, setOpen] = useState<boolean>(false);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (value) {
      addToQuote({ handleColor: value }, "handleColor");
      if (findRequired("Handle Finish")) removeRequired("Handle Finish");
    } else {
      addToQuote({ handleColor: "" }, "handleColor");
    }
  };

  const handleClose = () => setOpen(false);

  const handleOpen = () => setOpen(true);

  const handleClickWithHandle = (label: string) => {
    const checked = label === withHandleChoice;

    if (checked) {
      addToQuote({ withHandle: "", handleStyle: "" }, "handleStyle");
    } else {
      addToQuote({
        withHandle: label,
        handleStyle: "Touch Handle",
        // handleStyle: doorType?.includes("Window")
        //   ? "Surface Mount"
        //   : "Touch Handle",
      });
      if (findRequired("Handle Set")) removeRequired("Handle Set");
    }
  };

  const handleClickWithKey = (label: string) => {
    const checked = label === withKeyChoice;

    if (checked) {
      addToQuote({ withKey: "" });
    } else {
      addToQuote({ withKey: label });

      if (findRequired("Handle Key option")) {
        removeRequired("Handle Key option");
      }
    }
  };

  const isWindow = doorType?.includes("Window");

  const isBifold = doorType?.includes("Bi-fold");

  return {
    isWindow,
    isBifold,
    handleClickWithKey,
    handleClickWithHandle,
    handleOpen,
    handleClose,
    handleChange,
    open,
    finish,
    handleStyle,
    withHandleChoice,
    withKeyChoice,
  };
}

export default useAlumHandleSelector;
